import React, { useEffect } from "react";

import cogoToast from "cogo-toast";
import { useSelector, shallowEqual } from "react-redux";
import { Tab, Nav, Row, Col, Button } from "react-bootstrap";
import { useGetSocialUserQuery, useSyncSocialUserMutation } from "../../../../../../../../redux/apiSlice";
import { UserRelationshipsTable } from "../../../../../../SocialManagement/components/UserRelationshipsTable";
import { SocialPostsTab } from "../../../../../../SocialManagement/components/SocialPostsTab";
import { SocialSubscribers } from "../../../../../../SocialManagement/components/SocialSubscribers";
import { SocialSubscriptionsTable } from "../../../../../../SocialManagement/components/SocialSubscriptionsTable";
import { formatDate } from "../../../../../../../util/Helpers";



const Social = (props) => {
  const details = useSelector(
    ({ selectedUser }) => selectedUser.data.profile,
    shallowEqual
  );

  const { isFetching, data } = useGetSocialUserQuery(details?.userId)


  const [
    syncUser,
    { isLoading: isSyncing, isSuccess: syncedSuccessfully },
  ] = useSyncSocialUserMutation();

  useEffect(() => {
    if (syncedSuccessfully) {
      cogoToast.success("User synchronized successfully");
    }
  }, [syncedSuccessfully]);

  return (
    <div className="card card-custom h-100">
      <div className="card-header border-0">
        <div className="card-title pt-5 w-100">
          <h3 className="card-label">
            <span className="d-block text-dark h3 font-weight-bolder">
              Social Profile
            </span>
            <span className="d-block text-muted mt-2 font-size-sm">
              User's Social Profile
            </span>
          </h3>
        </div>
      </div>

      {!isFetching &&
        (data ? (
          <div className="card-body p-0 pb-8">
            <Tab.Container defaultActiveKey="">
              <div className={"d-flex flex-column px-0 h-100"}>
                <Nav
                  className="d-flex w-100 px-6 border-bottom align-items-center bg-white position-sticky top-0"
                  style={{
                    height: "46px",
                    zIndex: 1,
                  }}
                >
                  <Nav.Item>
                    <Nav.Link className="px-3" eventKey="">
                      Profile
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link className="px-3" eventKey="followers">
                      Followers
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link className="px-3" eventKey="following">
                      Following
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link className="px-3" eventKey="posts">
                      Posts
                    </Nav.Link>
                  </Nav.Item>
                    <Nav.Item>
                      <Nav.Link className="px-3" eventKey="subscribers">
                        Subscribers
                      </Nav.Link>
                    </Nav.Item>
                  <Nav.Item>
                    <Nav.Link className="px-3" eventKey="subscriptions">
                      Subscriptions
                    </Nav.Link>
                  </Nav.Item>
                </Nav>

                <Tab.Content className="flex-grow-1 px-5">
                  <Tab.Pane eventKey="">
                    <Row className="align-items-center justify-content-center my-6">
                      <Col
                        className="rounded-circle bg-gray-100 overflow-hidden d-flex justify-content-center align-items-center"
                        style={{ height: "128px", width: "128px", maxWidth: "128px" }}
                      >
                        <img src={data?.data?.imageUrl} className="w-100 h-100 object-fit-cover" />
                      </Col>
                    </Row>
                    <Row className="align-items-center justify-content-center">
                      <h1 className={"display-4 mb-4 font-weight-bold"}>{data?.data?.username}</h1>
                    </Row>
                    {[
                      { label: "User Name", value: data?.data?.username },
                      { label: "Display Name", value: data?.data?.displayName },
                      { label: "Level", value: data?.data?.userLevel },
                      { label: "Followers", value: data?.data?.followsCount },
                      { label: "Following", value: data?.data?.followerCount },
                      { label: "Rating", value: data?.data?.rating },
                      { label: "Post Count", value: data?.data?.postCount },
                      { label: "Status", value: data?.data?.status },
                      { label: "Transaction Count", value: data?.data?.transactionCount },
                      { label: "Profile Created", value: formatDate(data?.data?.created) },
                    ].map((item, idx) => (
                      <Row key={idx} className="align-items-center justify-content-center pb-2">
                        <Col className={"px-2 font-weight-bolder text-right"}>{item.label}</Col>
                        <Col className={"px-2"}>{item.value}</Col>
                      </Row>
                    ))}


                  </Tab.Pane>
                  <Tab.Pane eventKey="followers" className="h-100">
                    <UserRelationshipsTable profileId={data?.data?.profileId} side="followers" />
                  </Tab.Pane>
                  <Tab.Pane eventKey="following" className="h-100">
                    <UserRelationshipsTable profileId={data?.data?.profileId} side="following" />
                  </Tab.Pane>
                  <Tab.Pane eventKey="posts" className="h-100">
                    <SocialPostsTab
                     details={details} 
                     profileId={data?.data?.profileId}
                     postId={data?.data?.postId}  />
                  </Tab.Pane>

                  
                    <Tab.Pane eventKey="subscribers" className="h-100">
                      <SocialSubscribers details={details} />
                    </Tab.Pane>
                
                  <Tab.Pane eventKey="subscriptions" className="h-100">
                    <SocialSubscriptionsTable details={details} />
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </Tab.Container>
          </div>
        ) : (
          <div className="h-100 d-flex flex-column align-items-center justify-content-center">
            <h6>This user does not have a social profile</h6>
            <Button
              disabled={isSyncing}
              variant="dark"
              onClick={() => {
                const dataToSend = {
                  userId: details?.userId,
                  userGroup: details?.userGroup,
                };
                syncUser(dataToSend);
              }}
            >
              Create Social Profile
            </Button>
          </div>
        ))}
    </div>
  );
};

export default Social;
